// extracted by mini-css-extract-plugin
module.exports = {"button":"RegistrationButton_button__3fdo_"};